import { render, staticRenderFns } from "./metabase.vue?vue&type=template&id=1fd277eb&scoped=true"
import script from "./metabase.vue?vue&type=script&lang=js"
export * from "./metabase.vue?vue&type=script&lang=js"
import style0 from "./metabase.vue?vue&type=style&index=0&id=1fd277eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd277eb",
  null
  
)

export default component.exports